import React from "react";
import { Button } from "semantic-ui-react";
import styled from "styled-components";
import { palette } from "@conserveit/blocks";
import { Trans } from "@lingui/macro";
import SiteDetailsModal from "./SiteDetailsModal";

const StyledButton = styled(Button)`
  width: 100px;
  padding-left: 0 !important;
  padding-right: 0 !important;
  color: ${palette.pureWhite} !important;
  background-color: ${palette.success} !important;
`;

const StyledText = styled.p`
  color: ${palette.success};
  text-transform: uppercase;
`;

interface Props {
  onModalConfirm: () => void;
  onModalCancel: () => void;
  message?: string;
}

const SaveModal: React.FC<Props> = ({ onModalConfirm, onModalCancel, message }) => {
  return (
    <SiteDetailsModal
      iconSrc="https://conserveit-images.s3.ap-southeast-2.amazonaws.com/icons/site-details_save-round.png"
      iconAlt="Save icon - green floppy disk"
      actionDescription={
        <StyledText>
          <Trans id="site_details.modal.action_confirmation_save">save</Trans>
        </StyledText>
      }
      confirmButton={
        <StyledButton
          data-testid="save-modal__save-button"
          onClick={onModalConfirm}
        >
          <Trans id="site_details.save">Save</Trans>
        </StyledButton>
      }
      onModalCancel={onModalCancel}
      message={message}
    />
  );
};

export default SaveModal;
